export default "__VITE_ASSET__CShusgHu__ 584w";